module.exports = __webpack_public_path__ + "img/Token_p4.6dec3882.png";